import { handleStorageClear } from './auth';

export const apiClient = async (params, args = {}) => {
  let finalArgs = args;
  const authToken = localStorage.getItem('auth');
  const refreshToken = localStorage.getItem('refresh');

  finalArgs['headers'] = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    ...(finalArgs?.headers || {})
  };

  if (authToken) {
    finalArgs['headers']['Authorization'] = `Bearer ${authToken}`;
  }

  return new Promise((resolve) =>
    fetch(params, finalArgs).then(async (result) => {
      if (result.status === 401) {
        if (refreshToken) {
          const refreshResult = await fetch(`${process.env.REACT_APP_API_URL}common/o/token/`, {
            method: 'POST',
            body: JSON.stringify({
              grant_type: 'refresh_token',
              refresh_token: refreshToken,
              client_id: process.env.REACT_APP_CLIENT_ID
            })
          });

          if (refreshResult.status === 200) {
            const { access_token, refresh_token } = await refreshResult.json();
            localStorage.setItem('auth', access_token);
            localStorage.setItem('refresh', refresh_token);
            finalArgs['headers']['Authorization'] = `Bearer ${access_token}`;

            return resolve(fetch(params, finalArgs));
          } else {
            handleStorageClear();
          }
        } else {
          handleStorageClear();
        }
      }
      return resolve(result);
    })
  );
};

export const getDropdownOptions = async () => {
  const res = await apiClient(`${process.env.REACT_APP_API_URL}common/options/`);

  return res.json();
};
